import {
  AddCircleOutlineOutlined as AddCircleOutlineOutlinedIcon,
  ExitToApp as ExitToAppIcon,
  ExpandLess as ExpandLessIcon,
  ExpandMore as ExpandMoreIcon,
  HelpOutlineOutlined as HelpOutlineOutlinedIcon,
  PowerSettingsNewOutlined as PowerSettingsNewOutlinedIcon,
  SettingsOutlined as SettingsOutlinedIcon,
  SupervisorAccountOutlined as SupervisorAccountOutlinedIcon,
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Collapse,
  Grid,
  List,
  ListItem,
  ListItemAvatar,
  ListItemIcon,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import React, { useMemo, useState } from "react";
import { NavLink, useNavigate } from "react-router-dom";

import NavItem from "./NatItem";
import { adminMenu, menuPrincipal, settingsMenu } from "./DrawerLinks.config";

const DrawerLinks = ({ empresa, open, auth, setOpen }) => {
  const navigate = useNavigate();
  const [openCollapse, setOpenCollapse] = useState(false);
  const [openCollapseAdmin, setOpenCollapseAdmin] = useState(false);
  const isContaTemporaria = useMemo(
    () =>
      empresa?.tipoConta === "TEMPORARIA" ||
      empresa?.tipoConta === "TEMPORARIA_EXTENDED",
    [empresa]
  );
  const isWideScreen = useMediaQuery("(min-width:600px)");

  const marginTop = useMemo(() => {
    if (!isContaTemporaria) return 0;
    return isWideScreen ? "30px" : "60px";
  }, [isContaTemporaria, isWideScreen]);

  const handleCriarNovaEmpresa = () => navigate("/NovaEmpresa");
  const handleSair = () => {
    auth.logout();
    navigate("/login");
  };

  const toggleCollapse = (stateSetter) => () => stateSetter((prev) => !prev);

  return (
    <Box width="100%" paddingRight="1rem" height="100%">
      <Box sx={{ marginTop }}>
        <NavLink to="/Cadastro" onClick={() => setOpen(false)}>
          <ListItem
            sx={[
              {
                display: "flex",
                width: "100%",
              },
              open
                ? {
                    justifyContent: "center",
                  }
                : {
                    justifyContent: "normal",
                  },
            ]}
            as={Button}
          >
            <ListItemAvatar>
              <Avatar
                variant={empresa?.formatoLogo}
                alt={empresa?.nome}
                src={empresa?.urlLogo}
                sx={[
                  {
                    mt: 2,
                    color: "#253257",
                    paddingTop: isContaTemporaria && !open ? "2rem" : 0,

                    "&:hover": {
                      opacity: 0.5,
                    },
                  },
                  open
                    ? {
                        width: "150px",
                      }
                    : {
                        width: null,
                      },
                  open
                    ? {
                        height: "150px",
                      }
                    : {
                        height: null,
                      },
                  open
                    ? {
                        fontSize: "3em",
                      }
                    : {
                        fontSize: null,
                      },
                ]}
              >
                <strong style={{ fontFamily: "Bebas Neue", fontWeight: 600 }}>
                  {empresa?.nome?.substr(0, 2)}
                </strong>
              </Avatar>
            </ListItemAvatar>
          </ListItem>
          <ListItem
            sx={[
              {
                padding: "0.6rem",
                fontSize: "20px",
                marginRight: "36px",
              },
              open
                ? {
                    display: "flex",
                  }
                : {
                    display: "none",
                  },
            ]}
            as={Button}
          >
            <Grid width="100%" container>
              <strong
                style={{
                  fontFamily: "Bebas Neue",
                  fontSize: "24px",
                  textAlign: "center",
                  width: "100%",
                }}
              >
                {auth.getProfile() === null ? "NOME RESTAURANTE" : empresa.nome}
              </strong>
            </Grid>
          </ListItem>
        </NavLink>
      </Box>
      <List sx={{ minWidth: "100%" }}>
        {menuPrincipal.map(({ to, label, icon }) => (
          <NavItem
            setOpen={setOpen}
            key={to}
            to={to}
            label={label}
            icon={icon}
            open={open}
          />
        ))}
        <Tooltip
          title={<Typography color="inherit">Configurações</Typography>}
          arrow
          placement="right"
        >
          <ListItem as={Button} onClick={toggleCollapse(setOpenCollapse)}>
            <ListItemIcon>
              <Avatar sx={{ backgroundColor: "#F2C26A", color: "#253257" }}>
                <SettingsOutlinedIcon />
              </Avatar>
            </ListItemIcon>
            {open && (
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  width: "100%",
                  justifyContent: "space-between",
                }}
              >
                <Typography fontFamily="Bebas Neue" fontSize="20px">
                  Configurações
                </Typography>
                {openCollapse ? <ExpandLessIcon /> : <ExpandMoreIcon />}
              </Box>
            )}
          </ListItem>
        </Tooltip>

        <Collapse in={openCollapse} timeout="auto" unmountOnExit>
          <List
            sx={[
              open
                ? {
                    marginLeft: "0.5rem",
                  }
                : {
                    marginLeft: "0rem",
                  },
            ]}
            component="div"
            disablePadding
          >
            {settingsMenu.map(({ to, label, icon }) => (
              <NavItem
                key={to}
                to={to}
                label={label}
                icon={icon}
                open={open}
                setOpen={setOpen}
              />
            ))}
          </List>
        </Collapse>

        {auth.isAdmin() && (
          <>
            <Tooltip
              title={
                <Typography color="inherit">Configurações Suporte</Typography>
              }
              arrow
              placement="right"
            >
              <ListItem
                as={Button}
                onClick={toggleCollapse(setOpenCollapseAdmin)}
              >
                <ListItemIcon>
                  <Avatar sx={{ backgroundColor: "#F2C26A", color: "#253257" }}>
                    <SupervisorAccountOutlinedIcon />
                  </Avatar>
                </ListItemIcon>
                {open && (
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      width: "100%",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography fontFamily="Bebas Neue" fontSize="20px">
                      Suporte
                    </Typography>
                    {openCollapseAdmin ? (
                      <ExpandLessIcon />
                    ) : (
                      <ExpandMoreIcon />
                    )}
                  </Box>
                )}
              </ListItem>
            </Tooltip>

            <Collapse in={openCollapseAdmin} timeout="auto" unmountOnExit>
              <List
                sx={[
                  open
                    ? {
                        marginLeft: "0.5rem",
                      }
                    : {
                        marginLeft: "0rem",
                      },
                ]}
                component="div"
                disablePadding
              >
                <Tooltip
                  title={
                    <Typography color="inherit">
                      Cadastro de Empresas
                    </Typography>
                  }
                  arrow
                  placement="right"
                >
                  <ListItem onClick={handleCriarNovaEmpresa} as={Button}>
                    <ListItemAvatar>
                      <Avatar
                        sx={{ backgroundColor: "#F2C26A", color: "#253257" }}
                      >
                        <AddCircleOutlineOutlinedIcon />
                      </Avatar>
                    </ListItemAvatar>
                    {open && (
                      <Typography fontFamily="Bebas Neue" fontSize="20px">
                        Cadastro de Empresas
                      </Typography>
                    )}
                  </ListItem>
                </Tooltip>

                {adminMenu.map(({ to, label, icon }) => (
                  <NavItem
                    key={to}
                    to={to}
                    setOpen={setOpen}
                    label={label}
                    icon={icon}
                    open={open}
                  />
                ))}
              </List>
            </Collapse>
          </>
        )}

        {auth.loggedIn() ? (
          <Tooltip
            title={<Typography color="inherit">Sair</Typography>}
            arrow
            placement="right"
          >
            <ListItem as={Button} onClick={handleSair}>
              <ListItemAvatar>
                <Avatar sx={{ backgroundColor: "#F2C26A", color: "#253257" }}>
                  <ExitToAppIcon />
                </Avatar>
              </ListItemAvatar>
              {open && (
                <Typography fontFamily="Bebas Neue" fontSize="20px">
                  Sair
                </Typography>
              )}
            </ListItem>
          </Tooltip>
        ) : (
          <NavLink to="/Login">
            <ListItem as={Button}>
              <ListItemAvatar>
                <Avatar sx={{ backgroundColor: "#F2C26A", color: "#253257" }}>
                  <PowerSettingsNewOutlinedIcon />
                </Avatar>
              </ListItemAvatar>
              {open && (
                <Typography fontFamily="Bebas Neue" fontSize="20px">
                  Acessar
                </Typography>
              )}
            </ListItem>
          </NavLink>
        )}

        <Tooltip
          title={<Typography color="inherit">Ajuda</Typography>}
          arrow
          placement="right"
        >
          <ListItem
            as={Button}
            onClick={() => window.open("https://qrpedir.com/suporte", "_blank")}
          >
            <ListItemAvatar>
              <Avatar sx={{ backgroundColor: "#F2C26A", color: "#253257" }}>
                <HelpOutlineOutlinedIcon />
              </Avatar>
            </ListItemAvatar>
            {open && (
              <Typography fontFamily="Bebas Neue" fontSize="20px">
                Ajuda
              </Typography>
            )}
          </ListItem>
        </Tooltip>
      </List>
    </Box>
  );
};

export default DrawerLinks;
